module.exports = __webpack_public_path__ + "static/media/add.a6eb96c8.png";